var render = function render(){
  var _vm$sellerInfo, _vm$sellerInfo$organi, _vm$sellerInfo$organi2, _vm$sellerInfo2, _vm$sellerInfo2$offic;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-card-group', {
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    staticClass: "heading-myaccount",
    attrs: {
      "no-body": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('router-link', {
          attrs: {
            "button": "",
            "to": `/my-order?profile=My Orders`
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": "arrow-left-short"
          }
        })], 1), _c('span', {
          staticClass: "ml-2"
        }, [_vm._v("Need Help")])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-list-group', {
    attrs: {
      "flush": ""
    }
  }, [_c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "to": {
        path: '/faq',
        query: {
          needHelp: 'FAQ',
          orderNumber: this.orderNumber
        }
      }
    }
  }, [_c('b-icon-question-circle-fill', {
    staticClass: "mr-2"
  }), _vm._v(" " + _vm._s(_vm.$t("accountDetails.faq")) + " ")], 1), _c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "to": {
        path: '/Contact',
        query: {
          needHelp: 'Contact US',
          orderNumber: this.orderNumber
        }
      }
    }
  }, [_c('b-icon-envelope-fill', {
    staticClass: "mr-2"
  }), _vm._v(" " + _vm._s(_vm.$t("contactUs.title")) + " ")], 1), _c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "to": {
        path: '/terms_conditions',
        query: {
          needHelp: 'Terms & Conditions',
          orderNumber: this.orderNumber
        }
      }
    }
  }, [_c('b-icon-key-fill', {
    staticClass: "mr-2"
  }), _vm._v(" Terms & Condition ")], 1), _c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "to": {
        path: '/privacy-policy',
        query: {
          needHelp: 'Privacy Policy',
          orderNumber: this.orderNumber
        }
      }
    }
  }, [_c('b-icon-shield-lock-fill', {
    staticClass: "mr-2"
  }), _vm._v(" Privacy Policy ")], 1), _c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "to": {
        path: '/support-ticket',
        query: {
          needHelp: 'Support Ticket',
          orderNumber: this.orderNumber
        }
      }
    }
  }, [_c('b-icon-text-indent-left', {
    staticClass: "mr-2"
  }), _vm._v(" Support Ticket ")], 1)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "profile-maindv"
  }, [_c('h4', [_c('b', [_vm._v("Store Details")])]), _c('div', {}, [_c('div', {
    staticClass: "seller-main-info d-flex align-items-center flex-wrap flex-md-nowrap mb-2"
  }, [(_vm$sellerInfo = _vm.sellerInfo) !== null && _vm$sellerInfo !== void 0 && (_vm$sellerInfo$organi = _vm$sellerInfo.organization) !== null && _vm$sellerInfo$organi !== void 0 && (_vm$sellerInfo$organi2 = _vm$sellerInfo$organi.logo) !== null && _vm$sellerInfo$organi2 !== void 0 && _vm$sellerInfo$organi2.url ? [_c('b-img', {
    staticClass: "seller-img mr-3 mb-2 mb-md-0",
    attrs: {
      "src": _vm.sellerInfo.organization.logo.url,
      "alt": "Seller Logo",
      "fluid": ""
    }
  })] : _vm._e(), _c('p', {
    staticClass: "provideName mb-2"
  }, [_vm._v(_vm._s(_vm.providerName))])], 2), _c('div', {
    staticClass: "seller-address d-flex align-items-start mb-1"
  }, [_c('b-icon', {
    staticClass: "address-icon",
    attrs: {
      "icon": "geo-alt-fill"
    }
  }), _c('div', {
    staticClass: "ml-2"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" " + _vm._s((_vm$sellerInfo2 = _vm.sellerInfo) !== null && _vm$sellerInfo2 !== void 0 && (_vm$sellerInfo2$offic = _vm$sellerInfo2.office) !== null && _vm$sellerInfo2$offic !== void 0 && _vm$sellerInfo2$offic.address ? `${_vm.sellerInfo.office.address.street1}, ${_vm.sellerInfo.office.address.city}, ${_vm.sellerInfo.office.address.state} - ${_vm.sellerInfo.office.address.zip}` : "") + " ")])])], 1), _c('div', {
    staticClass: "infoNeedHelp mt-0"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('b-icon', {
    attrs: {
      "icon": "envelope-fill"
    }
  }), _c('p', {
    staticClass: "ml-2 mb-0 text-break"
  }, [_vm._v(_vm._s(_vm.sellerMail))])], 1), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-icon', {
    attrs: {
      "icon": "telephone-forward-fill"
    }
  }), _c('p', {
    staticClass: "ml-2 mb-0 text-break"
  }, [_vm._v(_vm._s(_vm.sellerPhone))])], 1)])])])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }